"use strict";function stop$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.stop$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="ui.pullToRefresh.stop";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.stop$=stop$,exports.default=stop$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/ui/pullToRefresh/stop.js
// module id = 1100
// module chunks = 106